import { Page } from 'src/app/core/models/page';
import { SortOrder } from 'src/app/core/interface/sort-order';
export class DOAbnormalTableDetailGetRequest extends Page {
  moNo: string;
  sortOrder: SortOrder | null;

  constructor() {
    super();
    this.moNo = '';
    this.sortOrder = null;
  }
}
